import React, { useState } from 'react';
import './Styles.css'; // Import your main styles
import { logInWithEmailAndPassword, signInWithGoogle } from './firebase';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    logInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        navigate('/');
        console.log(user);
      })
      .catch((error) => {
        
        alert('Account Not Found! Please Register');
      });
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      navigateToHomePage();
      // Handle the signed-in user as needed (e.g., update UI, store user data)
    } catch (error) {
      console.error('Google Sign-In failed:', error);
      alert('Google Sign-In failed. Please try again.');
    }
  };

  const navigateToHomePage = () => {
    navigate('/');
  };


  return (
    <div className='loginbottom'>
      <div className='formContainer'>
        <h4>Login</h4>
        
        <form onSubmit={handleSubmit}>
          <div>
            <label>Email:</label>
            <input type="email" value={email} onChange={handleEmailChange} />
          </div>
          <div>
            <label>Password:</label>
            <input type="password" value={password} onChange={handlePasswordChange}/>
          </div>
          <button type="submit" onClick={handleSubmit}>Login</button>
        </form>
        <p className="center-text">
          or 
        </p>

        <center>
          <div className='google-div'><img className='google' src="https://1000logos.net/wp-content/uploads/2016/11/Google-Symbol.png" alt="" onClick={handleGoogleSignIn} /></div>
        </center>


      

        
      </div>
    </div>
  );
};

export default Login;
